export default "__VITE_ASSET__141336c7__"